import React from 'react';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { FDStack, FDHeadlineText } from '@facet-wealth/design';
import BackButtonPicker
  from 'Views/Page/Content/Templates/WhatIfProposalPreviewTemplate/MainContentPicker/MainContentForScenarioSelectionRedefined/Header/BackButtonPicker';
import StatusChip
  from 'Views/Page/Content/Templates/WhatIfProposalPreviewTemplate/MainContentPicker/MainContentForScenarioSelectionRedefined/Header/StatusChip';

const Header = () => {
  const { pageContentResource } = usePageContentContext();

  return (
    <FDStack direction={'row'} spacing={2} wrap alignItems={'center'}>
      <BackButtonPicker />
      <FDHeadlineText size={'md'} value={pageContentResource.attr('proposalName')} color={'textPrimary'} />
      <StatusChip />
    </FDStack>
  );
};

Header.defaultProps = {
};

Header.propTypes = {
};

export default Header;
